import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionScope } from "@verbleif/lib/src/composables/Api/Type/UserPermissions/userPermission.enum";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class PropertyVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyRead,
      scope: PermissionScope.PROPERTY,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyDelete,
      scope: PermissionScope.PROPERTY,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyUpdate,
      scope: PermissionScope.PROPERTY,
    });
  };

  public canReadInventory: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyReadinventoryany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyReadinventory,
      scope: PermissionScope.PROPERTY,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationPropertyCreateany,
        PermissionAttributesEnum.GlobalOperationPropertyUpdateany,
        PermissionAttributesEnum.GlobalOperationPropertyDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationPropertyCreate,
        PermissionAttributesEnum.ContextOperationPropertyUpdate,
        PermissionAttributesEnum.ContextOperationPropertyDelete,
      ],
      scope: PermissionScope.PROPERTY,
    });
  };

  public canTools = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationPropertyTools,
    });
  };
}
